import {useQueryClient, useMutation} from 'react-query'
import {QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/TemplosListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseTemplosProvider'
import {deleteSelectedMediums} from '../../core/_requests'

const TemplosListGrouping = () => {
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  const deleteSelectedItems = useMutation(() => deleteSelectedMediums(selected), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // update detail view directly
      queryClient.invalidateQueries([`${QUERIES.TEMPLES_LIST}-${query}`])
      clearSelected()
    },
  })

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selecionado
      </div>

      <button
        type='button'
        className='btn btn-danger'
        onClick={async () => await deleteSelectedItems.mutateAsync()}
      >
        Excluir Selecionado
      </button>
    </div>
  )
}

export {TemplosListGrouping}
